import styled, { css } from 'styled-components';
import { colors, subtitle1, mediumShadow, spacing, subtitle2, duration, easing } from 'ui/theme';
import { FLOWCHART_Z_INDEXES } from 'modules/workflows/components/WorkflowFlowchart/WorkflowFlowchart.styles';
import { PANEL_WIDTH, REVIEW_PANEL_WIDTH } from 'ui/workflows/nodeTilePanel/NodeTilePanel.styled';
import { pxToRem } from 'utils/convert';

const shared = css<{ $moveAssitButton?: boolean }>`
  position: absolute;
  ${({ $moveAssitButton }) =>
    `right: calc(${pxToRem($moveAssitButton ? REVIEW_PANEL_WIDTH : PANEL_WIDTH)} + ${pxToRem(
      25,
    )})`};
  top: ${spacing.plusHalf};
  z-index: ${FLOWCHART_Z_INDEXES.TOOLBAR};
  ${mediumShadow};
`;

export const StyledDialog = styled.div<{ $highlightDialog?: boolean }>`
  ${shared}
  background: rgba(255, 255, 255, 0.88);
  border-radius: ${spacing.threeQuarter};
  width: ${pxToRem(360)};
  backdrop-filter: blur(6px);
  gap: ${spacing.base};
  display: flex;
  flex-direction: column;
  color: ${colors.textSecondary};
  padding: ${spacing.plusHalf};
  padding-top: ${spacing.base};
  transition: all ${duration.long} ${easing.entrance};
`;

const StyledTitle = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledHeader = styled(StyledTitle)<{ shiftRight?: boolean }>`
  justify-content: space-between;
  margin-bottom: -${spacing.quarter};
  ${({ shiftRight }) => shiftRight && `margin-right: -${spacing.threeQuarter};`}
`;

export const StyledHeaderLeft = styled(StyledTitle)`
  ${subtitle1};
  gap: ${spacing.half};
`;

export const StyledHeaderRight = styled(StyledTitle)`
  gap: ${spacing.half};
`;

export const StyledJourneyAssistClosed = styled.button<{ $moveAssitButton: boolean }>`
  ${shared}
  ${subtitle2}
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 1000px;
  background: ${colors.white};
  border: none;
  padding: ${spacing.threeQuarter};
  color: ${colors.textLink};
  transition: all ${duration.long} ${easing.entrance};
  gap: ${spacing.half};
  span {
    display: none;
  }

  &:hover {
    padding: ${spacing.threeQuarter} ${spacing.base};
    span {
      display: block;
    }
  }
`;
